import React from 'react';
import stryke from '../assets/partners/stryke.webp';
import orangeFinance from '../assets/partners/orangefinance.jpg';
import camelot from '../assets/partners/camelot.png';
import jonesDAO from '../assets/partners/jonesdao.png';
import maiaDAO from '../assets/partners/maia.jpg';
import factorDAO from '../assets/partners/factor.png';
import bonsaiDAO from '../assets/partners/bondao.webp';
import sanko from '../assets/partners/sanko.webp';
import fanko from '../assets/partners/fanko.jpg';
import smoovie from '../assets/partners/smoovie.jpg';
import gamma from '../assets/partners/gamma.png';
import hermes from '../assets/partners/hermes.jpg';
import openocean from '../assets/partners/openocean.png';
import playarts from '../assets/partners/playarts.jpg';
import winr from '../assets/partners/winr.png';
import hamachi from '../assets/partners/hamachi.png';
import synonym from '../assets/partners/synonym.jpg';
import blueberry from '../assets/partners/blueberry.webp';
import azuki from '../assets/partners/azuki.png';
import silo from '../assets/partners/silo.png';

const Partners = () => {
  const sections = {
    "Core Partners": [
      { name: "CamelotDex", logo: camelot, description: "Facilitates decentralized trading with optimized liquidity pools on Arbitrum.", link: "https://camelot.exchange" },
      { name: "Stryke", logo: stryke, description: "Stryke is a decentralized options trading platform on Arbitrum, offering leveraged liquidity and innovative trading features.", link: "https://app.strike.org/dashboard" },
      { name: "JonesDAO", logo: jonesDAO, description: "Offers structured products for risk-managed DeFi investments.", link: "https://app.jonesdao.io/vaults" },
    ],
    "Swap tools": [
      { name: "HermesOmnichain", logo: hermes, description: "Offers bridgeless omnichain native token swaps and yield opportunities across various blockchains.", link: "https://app.maiadao.io/" },
      { name: "OpenOcean", logo: openocean, description: "OpenOcean aggregates liquidity from various blockchains to provide users with the best trading prices and seamless cross-chain swaps.", link: "https://openocean.finance" },
      { name: "GammaSwap", logo: gamma, description: "GammaSwap provides a DeFi protocol for trading volatility through on-chain perpetual options.", link: "https://gamma.xyz" }
    ],
    "Yield Farming & Investment platforms": [
      { name: "OrangeFinance", logo: orangeFinance, description: "Provides yield optimization strategies for DeFi assets.", link: "https://www.orangefinance.io/" },
      { name: "FactorDAO", logo: factorDAO, description: "Specializes in creating DeFi financial instruments like options and futures.", link: "https://factor.fi" },
      { name: "MaiaDAO", logo: maiaDAO, description: "A decentralized finance protocol for lending, borrowing, and yield farming.", link: "https://maiadao.io" },
      { name: "BonsaiDAO", logo: bonsaiDAO, description: "Focuses on leveraging collective intelligence for investment decisions in DeFi.", link: "https://BonsaiDAO.xyz" },
      { name: "Hamachi Finance", logo: hamachi, description: "Hamachi Finance offers a multi-currency, multi-chain reward token where holding $HAMI allows users to farm rewards and accumulate tokens across different supported projects on the Arbitrum chain.", link: "https://hamachi.finance" },
      { name: "Synonym Finance", logo: synonym, description: "Synonym Finance provides tools for crypto asset management, focusing on enabling users to bridge, stake, and earn rewards across multiple blockchains, enhancing interoperability.", link: "https://app.synonym.finance/" },
      { name: "Silo Finance", logo: silo, description: "Silo Finance on Arbitrum is a non-custodial lending protocol that offers risk-isolated markets where any token can be used as collateral for borrowing and lending.", link: "https://v2.silo.finance" },
    ],
    "Arbitrum L3 Orbit Chain Integrations": [
      { name: "Sanko", logo: sanko, description: "Sanko (DMT) is an Arbitrum Orbit Layer 3 blockchain tailored for gaming, using its native token DMT for gas and to facilitate in-game transactions and economies.", link: "https://sanko.io" },
      { name: "WINR", logo: winr, description: "Revolutionizes onchain gambling with instant, gasless bets.", link: "https://winr.games" },
    ],
    "Fun & Games": [
      { name: "PlayArtsDotAI", logo: playarts, description: "Playartsdotai is an AI-driven platform that allows users to create, mint, and trade digital art while integrating with blockchain technology for decentralized art experiences.", link: "https://playarts.ai" },
      { name: "GMX Blueberry Club", logo: blueberry, description: "The GMX Blueberry Club offers a collection of 10,000 unique NFTs on Arbitrum that provide community rewards and benefits, including exclusive access to trading competitions and potential yield", link: "https://hub.findgbc.io/" },
      { name: "Azuki", logo: azuki, description: "Leading NFT project integrating digital art with DeFi functionality.", link: "https://azuki.com" },
      { name: "Fanko", logo: fanko, description: "Fankotech: A memecoin launchpad on the Sanko chain, offering quick token creation, buying, and selling functionalities.", link: "https://fanko.tech" },
      { name: "Smoovie", logo: smoovie, description: "Smooviephone (SMOOVIE) is a token on the Sanko Orbit L3 chain, integrating DeFi with GameFi through prediction markets, mini-games, and staking options, enhancing user engagement and offering a deflationary token model.", link: "https://www.smooviephone.com/" }
    ]
  };

  const coreCreeds = [
    {
      title: "Fun First",
      description: "MemeFi takes the complexity out of DeFi and gives people something they can relate to and recognise."
    },
    {
      title: "Serious Finance, Memeatic Delivery",
      description: "Underneath the fun exterior, there's real, robust DeFi technology. Leveraging, trading, and earning are all part of the DeFi offering – but way more enjoyable."
    },
    {
      title: "Community-Centric",
      description: "It's all about the community vibes. Every MemeFi partnership has been carefully curated and negotiated to offer our community members the best experience."
    },
    {
      title: "Viral Potential",
      description: "Memes spread like wildfire, and so does MemeFi. It's finance that's built to be shared, making it easier than ever to get in on the action."
    }
  ];

  return (
    <div className="bg-gradient-to-r from-sky-50 via-sky-50/80 to-white min-h-screen pt-16 md:pt-20">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-8 md:py-16">
        {/* Header Section */}
        <div className="text-center mb-8 md:mb-16">
          <h1 className="text-3xl md:text-4xl font-bold text-sky-500 mb-4 md:mb-6">Welcome to MemeFi</h1>
          <p className="text-gray-600 text-base md:text-lg mb-6 md:mb-8 max-w-3xl mx-auto px-4">
            Where memes meet decentralized finance (DeFi). It's all about making finance not just something you have to deal with, but something you want to engage with, through the universal language of memes.
          </p>
        </div>

        {/* Core Creeds Section */}
        <div className="mb-12 md:mb-20">
          <h2 className="text-xl md:text-2xl font-bold text-sky-500 mb-6 md:mb-8 text-center">Our Core Creeds</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-8 px-4">
            {coreCreeds.map((creed, index) => (
              <div key={index} className="bg-white/80 backdrop-blur-sm p-4 md:p-6 rounded-xl border border-sky-200 hover:bg-white hover:border-sky-300 transition-all shadow-sm text-center">
                <h3 className="text-lg md:text-xl font-semibold text-sky-500 mb-2 md:mb-3">{creed.title}</h3>
                <p className="text-gray-600 text-sm md:text-base">{creed.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Partnerships Header */}
        <div className="text-center mb-8 md:mb-12 px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-sky-500 mb-3 md:mb-4">MemeFi Partnerships</h2>
          <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
            Building the future of meme finance with our trusted partners. Below you have a selection of projects that have integrated BOOP into their cutting-edge DeFi platforms.
          </p>
          <p className="text-gray-500 text-xs md:text-sm mt-2">
            Hover over them to learn more and boop the button to be redirected to the project's website!
          </p>
        </div>

        {/* Partners Sections */}
        {Object.entries(sections).map(([title, partners]) => (
          <section key={title} className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-bold text-sky-500 mb-4 md:mb-6 px-4 text-center">{title}</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 px-4">
              {partners.map((partner, index) => (
                <a
                  key={index}
                  href={partner.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/80 backdrop-blur-sm p-4 md:p-6 hover:bg-white rounded-xl transition-all duration-300 hover:transform hover:scale-105 flex flex-col border border-sky-200 hover:border-sky-300 shadow-sm aspect-auto md:aspect-square group text-center"
                >
                  <div className="bg-white/50 rounded-full p-4 md:p-6 mb-3 md:mb-4 flex items-center justify-center flex-shrink-0 group-hover:bg-white">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="w-16 h-16 md:w-24 md:h-24 object-contain"
                    />
                  </div>
                  <h3 className="text-sky-500 font-medium text-base md:text-lg mb-1 md:mb-2">{partner.name}</h3>
                  <p className="text-gray-600 text-xs md:text-sm">{partner.description}</p>
                </a>
              ))}
            </div>
          </section>
        ))}

        {/* Contact Section */}
        <div className="mt-12 md:mt-16 text-center px-4">
          <p className="text-gray-600 mb-4 md:mb-6">
            Want to become a partner?
          </p>
          <a
            href="https://t.me/boopthecoin"
            className="inline-flex items-center justify-center bg-sky-500 hover:bg-sky-600 text-white py-2 px-4 md:px-6 rounded-lg transition-colors text-sm md:text-base"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default Partners;